const merseyvapour = {
    id: 'merseyvapour',
    publicSiteName: 'Mersey Vapour',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#aa1212',
            secondary: '#020101',
            color1: '#e12727',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: true,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/merseyvapour/favicon.ico',
        logo: '/merseyvapour/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default merseyvapour